import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import dataMappingService from "@/services/dataMapping";

export const useDataMappingStore = defineStore("dataMapping", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchDataMappingFilesGrid(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.getDataMappingFilesGrid(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchFileDataMappingGrid(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.getFileDataMappingGrid(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchDataMappingStaticKeys(companyId) {
    loading.value = true;
    try {
      const res = await dataMappingService.getDataMappingStaticKeys(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchDataMappingSimilarStaticKeys(companyId) {
    loading.value = true;
    try {
      const res = await dataMappingService.getDataMappingSimilarStaticKeys(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchDataMappingSchemaKeys(companyId) {
    loading.value = true;
    try {
      const res = await dataMappingService.getDataMappingSchemaKeys(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchDataMappingSessionFields(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.getDataMappingSessionFields(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addDataMapping(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.addDataMapping(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editDataMapping(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.editDataMapping(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteDataMapping(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.deleteDataMapping(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteFileDataMapping(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.deleteFileDataMapping(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteFileDataMappingRow(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.deleteFileDataMappingRow(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function generateFileDataMapping(payload) {
    loading.value = true;
    try {
      const res = await dataMappingService.generateFileDataMapping(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchDataMappingFilesGrid,
    fetchFileDataMappingGrid,
    fetchDataMappingStaticKeys,
    fetchDataMappingSimilarStaticKeys,
    fetchDataMappingSchemaKeys,
    fetchDataMappingSessionFields,
    addDataMapping,
    editDataMapping,
    deleteDataMapping,
    deleteFileDataMapping,
    deleteFileDataMappingRow,
    generateFileDataMapping,
  };
});
